export default ({ userSettings }) => (moduleName) => {
  switch (moduleName) {
    case 'user-settings':
      return userSettings
    default:
      throw new Error(`Cannot find module '${moduleName}'`)
  }
}



// WEBPACK FOOTER //
// ./src/requireImpl.js